// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OT-main-content {
    margin-left: 280px;
    margin-bottom: 20px;
    padding: 10px 0px;
}

.OT-setting-bar {
    display: flex;
    align-items: center;
    /* padding: 17px 10px 10px 10px; */
    background-color: #f8f8f8;
    border-radius: 8px;
    margin-bottom: 10px;
    margin-right: 10px;
    margin-left: 10px;
}

/* Search Bar Styling */
.OT-search-bar {
    display: flex;
    flex: 1 1;
    gap: 10px;
}

.OT-search-bar input[type="text"] {
    flex: 1 1;
    height: 17px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    margin-left: 10px;
}

.OT-search-bar input[type="text"]:focus {
    border-color: #65CCB7;
    box-shadow: 0 0 5px rgba(101, 204, 183, 0.5);
    outline: none;
}

/* Disabled Button Styling */
#OT-search-button:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
}


.OT-filter-bar {
    display: flex;
    align-items: baseline;
    padding: 17px 10px 10px 10px;
    background-color: #f8f8f8;
    border-radius: 8px;
    margin-bottom: 10px;
    margin-right: 10px;
    margin-left: 10px;
}

.OT-filter-options {
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.OT-filter-options label {
    margin-right: 10px;
}

.OT-filter-options select {
    margin-right: 10px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

/* Adjusting Select input styling */
.css-1cprn2g-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    height: 50px !important; /* Shorter height */
    font-size: 14px; /* Adjust font size for balance */
    padding: 0 10px; /* Adjust padding */
}

.css-15k6ek6-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 6px 8px !important; /* Adjust padding inside the dropdown */
    line-height: 1.2; /* Adjust line height for better alignment */
}

.css-1sl1ukt-MuiChip-root {
    height: 22px !important; /* Adjust chip height for multi-select */
    font-size: 12px; /* Smaller font for chips */
    margin: 2px; /* Adjust spacing around chips */
}

.css-lc42l8-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 6px 8px !important; /* Ensure consistent padding */
    height: 1.6em !important;
}

/* Adjusting the overall dropdown container */
.MuiFormControl-root {
    margin: 0 10px; /* Reduce margin for compact spacing */
    width: 90%;
}

.MuiOutlinedInput-notchedOutline {
    border-radius: 5px; /* Keep consistent rounded corners */
}

/* Reduce dropdown list item height */
.MuiMenuItem-root {
    padding: 6px 12px; /* Adjust padding in dropdown options */
    font-size: 14px; /* Slightly smaller font */
}

/* Checkbox group styling */
.OT-checkbox-group {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    margin-right: 10px;
}

.OT-checkbox-group label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    transition: background-color 0.3s, border-color 0.3s;
    -webkit-user-select: none;
            user-select: none; /* Prevent text selection */
}

.OT-checkbox-group input[type="checkbox"] {
    cursor: pointer;
    accent-color: #65CCB7; /* Style the checkbox check color */
    margin-right: 5px;
}

/* Add background color when the checkbox is checked */
.OT-checkbox-group input[type="checkbox"]:checked + label {
    background-color: #e0f7f3;
    border-color: #65CCB7;
}

/* Hover effect for label */
.OT-checkbox-group label:hover {
    background-color: #f0f9f8;
    border-color: #65CCB7;
}

/* Date filters styling */
.OT-date-filters {
    display: flex;
    align-items: center;
    /* gap: 20px; */
    margin-right: 10px;
}

.OT-date-picker {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.OT-date-picker span {
    color: #555;
    margin-bottom: 4px;
}

.css-18pjc51-MuiFormLabel-root-MuiInputLabel-root {
    top: -7px !important; /* Override styles */
}

/* Specifically target placeholder */
.css-lc42l8-MuiInputBase-input-MuiOutlinedInput-input::placeholder {
    font-size: 12px !important;
    color: #999; /* Adjust placeholder color */
}

/* Adjust padding of the Select input */
.css-15k6ek6-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 8px 10px !important;
}

.css-1q964xs-MuiFormLabel-root-MuiInputLabel-root {
    font-size: 0.85rem !important; /* Make font size smaller */
    line-height: 1.3em !important;
    text-align: center; /* Center the text */
    transform: translate(50%, 50%) !important;
    transform-origin: center center !important;
    white-space: nowrap; /* Prevent wrapping */
    left: -15px !important;
}

/* Material-UI Date Picker input styling */
.MuiTextField-root {
    display: flex;
    align-items: center;

}

.MuiInputBase-root {
    border-radius: 5px;
    border: 1px solid #ccc;
    transition: border-color 0.3s, box-shadow 0.3s;
    background-color: #fff;
}

.MuiInputBase-root:hover {
    border-color: #65CCB7;
}

.MuiInputBase-root:focus-within {
    border-color: #65CCB7;
    box-shadow: 0 0 6px rgba(101, 204, 183, 0.3);
}

.MuiOutlinedInput-notchedOutline {
    border-color: #ccc;
}

.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #65CCB7;
}

/* Apply Filters Button */
.OT-apply-button {
    display: flex;
    align-items: center;
    gap: 10px; /* Space between buttons */
}

/* Apply Button Styling */
#OT-apply-button {
    height: 40px;
    padding: 10px 20px;
    background-color: #65CCB7; /* Primary turquoise color */
    color: white;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

#OT-apply-button:hover {
    background-color: #52b2a1; /* Slightly darker shade on hover */
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

#OT-apply-button:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
    box-shadow: none;
}

/* Reset Button Styling */
button[variant="outlined"] {
    height: 40px;
    padding: 10px 20px;
    background-color: #ffffff; /* White background */
    border: 2px solid #ddd;
    color: #65CCB7; /* Match theme */
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
}

button[variant="outlined"]:hover {
    background-color: #f0f8f3; /* Light turquoise on hover */
    border-color: #65CCB7;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

/* Disabled Reset Button */
button[variant="outlined"]:disabled {
    background-color: #f0f0f0;
    border-color: #ddd;
    color: #999;
    cursor: not-allowed;
    box-shadow: none;
}

/* Reset Button Icon Styling */
button[variant="outlined"] svg {
    font-size: 16px;
    color: #65CCB7;
}


#OT-search-button {
    height: 38px;
    padding: 8px 16px;
    background-color: #65CCB7;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 5px;
}

#OT-search-button:hover {
    background-color: #52b2a1;}`, "",{"version":3,"sources":["webpack://./src/origin tracker/OTFilterBar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAO;IACP,SAAS;AACb;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB,EAAE,mBAAmB;IAC5C,eAAe,EAAE,iCAAiC;IAClD,eAAe,EAAE,mBAAmB;AACxC;;AAEA;IACI,2BAA2B,EAAE,uCAAuC;IACpE,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;IACI,uBAAuB,EAAE,wCAAwC;IACjE,eAAe,EAAE,2BAA2B;IAC5C,WAAW,EAAE,gCAAgC;AACjD;;AAEA;IACI,2BAA2B,EAAE,8BAA8B;IAC3D,wBAAwB;AAC5B;;AAEA,6CAA6C;AAC7C;IACI,cAAc,EAAE,sCAAsC;IACtD,UAAU;AACd;;AAEA;IACI,kBAAkB,EAAE,oCAAoC;AAC5D;;AAEA,qCAAqC;AACrC;IACI,iBAAiB,EAAE,uCAAuC;IAC1D,eAAe,EAAE,0BAA0B;AAC/C;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,oDAAoD;IACpD,yBAAiB;YAAjB,iBAAiB,EAAE,2BAA2B;AAClD;;AAEA;IACI,eAAe;IACf,qBAAqB,EAAE,mCAAmC;IAC1D,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB,EAAE,oBAAoB;AAC9C;;AAEA,oCAAoC;AACpC;IACI,0BAA0B;IAC1B,WAAW,EAAE,6BAA6B;AAC9C;;AAEA,uCAAuC;AACvC;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B,EAAE,2BAA2B;IAC1D,6BAA6B;IAC7B,kBAAkB,EAAE,oBAAoB;IACxC,yCAAyC;IACzC,0CAA0C;IAC1C,mBAAmB,EAAE,qBAAqB;IAC1C,sBAAsB;AAC1B;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,0BAA0B;AACzC;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,4BAA4B;IACvD,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB,EAAE,mCAAmC;IAC9D,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,qBAAqB;IAChD,sBAAsB;IACtB,cAAc,EAAE,gBAAgB;IAChC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB,EAAE,6BAA6B;IACxD,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,CAAC","sourcesContent":[".OT-main-content {\r\n    margin-left: 280px;\r\n    margin-bottom: 20px;\r\n    padding: 10px 0px;\r\n}\r\n\r\n.OT-setting-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    /* padding: 17px 10px 10px 10px; */\r\n    background-color: #f8f8f8;\r\n    border-radius: 8px;\r\n    margin-bottom: 10px;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n}\r\n\r\n/* Search Bar Styling */\r\n.OT-search-bar {\r\n    display: flex;\r\n    flex: 1;\r\n    gap: 10px;\r\n}\r\n\r\n.OT-search-bar input[type=\"text\"] {\r\n    flex: 1;\r\n    height: 17px;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n    transition: all 0.3s;\r\n    margin-left: 10px;\r\n}\r\n\r\n.OT-search-bar input[type=\"text\"]:focus {\r\n    border-color: #65CCB7;\r\n    box-shadow: 0 0 5px rgba(101, 204, 183, 0.5);\r\n    outline: none;\r\n}\r\n\r\n/* Disabled Button Styling */\r\n#OT-search-button:disabled {\r\n    background-color: #e0e0e0;\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n.OT-filter-bar {\r\n    display: flex;\r\n    align-items: baseline;\r\n    padding: 17px 10px 10px 10px;\r\n    background-color: #f8f8f8;\r\n    border-radius: 8px;\r\n    margin-bottom: 10px;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.OT-filter-options {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-right: 10px;\r\n}\r\n\r\n.OT-filter-options label {\r\n    margin-right: 10px;\r\n}\r\n\r\n.OT-filter-options select {\r\n    margin-right: 10px;\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n}\r\n\r\n/* Adjusting Select input styling */\r\n.css-1cprn2g-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\r\n    height: 50px !important; /* Shorter height */\r\n    font-size: 14px; /* Adjust font size for balance */\r\n    padding: 0 10px; /* Adjust padding */\r\n}\r\n\r\n.css-15k6ek6-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\r\n    padding: 6px 8px !important; /* Adjust padding inside the dropdown */\r\n    line-height: 1.2; /* Adjust line height for better alignment */\r\n}\r\n\r\n.css-1sl1ukt-MuiChip-root {\r\n    height: 22px !important; /* Adjust chip height for multi-select */\r\n    font-size: 12px; /* Smaller font for chips */\r\n    margin: 2px; /* Adjust spacing around chips */\r\n}\r\n\r\n.css-lc42l8-MuiInputBase-input-MuiOutlinedInput-input {\r\n    padding: 6px 8px !important; /* Ensure consistent padding */\r\n    height: 1.6em !important;\r\n}\r\n\r\n/* Adjusting the overall dropdown container */\r\n.MuiFormControl-root {\r\n    margin: 0 10px; /* Reduce margin for compact spacing */\r\n    width: 90%;\r\n}\r\n\r\n.MuiOutlinedInput-notchedOutline {\r\n    border-radius: 5px; /* Keep consistent rounded corners */\r\n}\r\n\r\n/* Reduce dropdown list item height */\r\n.MuiMenuItem-root {\r\n    padding: 6px 12px; /* Adjust padding in dropdown options */\r\n    font-size: 14px; /* Slightly smaller font */\r\n}\r\n\r\n/* Checkbox group styling */\r\n.OT-checkbox-group {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    flex-wrap: wrap;\r\n    margin-right: 10px;\r\n}\r\n\r\n.OT-checkbox-group label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    transition: background-color 0.3s, border-color 0.3s;\r\n    user-select: none; /* Prevent text selection */\r\n}\r\n\r\n.OT-checkbox-group input[type=\"checkbox\"] {\r\n    cursor: pointer;\r\n    accent-color: #65CCB7; /* Style the checkbox check color */\r\n    margin-right: 5px;\r\n}\r\n\r\n/* Add background color when the checkbox is checked */\r\n.OT-checkbox-group input[type=\"checkbox\"]:checked + label {\r\n    background-color: #e0f7f3;\r\n    border-color: #65CCB7;\r\n}\r\n\r\n/* Hover effect for label */\r\n.OT-checkbox-group label:hover {\r\n    background-color: #f0f9f8;\r\n    border-color: #65CCB7;\r\n}\r\n\r\n/* Date filters styling */\r\n.OT-date-filters {\r\n    display: flex;\r\n    align-items: center;\r\n    /* gap: 20px; */\r\n    margin-right: 10px;\r\n}\r\n\r\n.OT-date-picker {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n}\r\n\r\n.OT-date-picker span {\r\n    color: #555;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.css-18pjc51-MuiFormLabel-root-MuiInputLabel-root {\r\n    top: -7px !important; /* Override styles */\r\n}\r\n\r\n/* Specifically target placeholder */\r\n.css-lc42l8-MuiInputBase-input-MuiOutlinedInput-input::placeholder {\r\n    font-size: 12px !important;\r\n    color: #999; /* Adjust placeholder color */\r\n}\r\n\r\n/* Adjust padding of the Select input */\r\n.css-15k6ek6-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\r\n    padding: 8px 10px !important;\r\n}\r\n\r\n.css-1q964xs-MuiFormLabel-root-MuiInputLabel-root {\r\n    font-size: 0.85rem !important; /* Make font size smaller */\r\n    line-height: 1.3em !important;\r\n    text-align: center; /* Center the text */\r\n    transform: translate(50%, 50%) !important;\r\n    transform-origin: center center !important;\r\n    white-space: nowrap; /* Prevent wrapping */\r\n    left: -15px !important;\r\n}\r\n\r\n/* Material-UI Date Picker input styling */\r\n.MuiTextField-root {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n}\r\n\r\n.MuiInputBase-root {\r\n    border-radius: 5px;\r\n    border: 1px solid #ccc;\r\n    transition: border-color 0.3s, box-shadow 0.3s;\r\n    background-color: #fff;\r\n}\r\n\r\n.MuiInputBase-root:hover {\r\n    border-color: #65CCB7;\r\n}\r\n\r\n.MuiInputBase-root:focus-within {\r\n    border-color: #65CCB7;\r\n    box-shadow: 0 0 6px rgba(101, 204, 183, 0.3);\r\n}\r\n\r\n.MuiOutlinedInput-notchedOutline {\r\n    border-color: #ccc;\r\n}\r\n\r\n.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n    border-color: #65CCB7;\r\n}\r\n\r\n/* Apply Filters Button */\r\n.OT-apply-button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px; /* Space between buttons */\r\n}\r\n\r\n/* Apply Button Styling */\r\n#OT-apply-button {\r\n    height: 40px;\r\n    padding: 10px 20px;\r\n    background-color: #65CCB7; /* Primary turquoise color */\r\n    color: white;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease-in-out;\r\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n#OT-apply-button:hover {\r\n    background-color: #52b2a1; /* Slightly darker shade on hover */\r\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n#OT-apply-button:disabled {\r\n    background-color: #e0e0e0;\r\n    cursor: not-allowed;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Reset Button Styling */\r\nbutton[variant=\"outlined\"] {\r\n    height: 40px;\r\n    padding: 10px 20px;\r\n    background-color: #ffffff; /* White background */\r\n    border: 2px solid #ddd;\r\n    color: #65CCB7; /* Match theme */\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    transition: all 0.3s ease-in-out;\r\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\nbutton[variant=\"outlined\"]:hover {\r\n    background-color: #f0f8f3; /* Light turquoise on hover */\r\n    border-color: #65CCB7;\r\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Disabled Reset Button */\r\nbutton[variant=\"outlined\"]:disabled {\r\n    background-color: #f0f0f0;\r\n    border-color: #ddd;\r\n    color: #999;\r\n    cursor: not-allowed;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Reset Button Icon Styling */\r\nbutton[variant=\"outlined\"] svg {\r\n    font-size: 16px;\r\n    color: #65CCB7;\r\n}\r\n\r\n\r\n#OT-search-button {\r\n    height: 38px;\r\n    padding: 8px 16px;\r\n    background-color: #65CCB7;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n}\r\n\r\n#OT-search-button:hover {\r\n    background-color: #52b2a1;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
